import meterRegular from "@/static/data/document.meter.regular.json";
import meterMaas from "@/static/data/document.meter.maas.json";
import panels from "@/static/data/document.panels.json";
import tenant from "@/static/data/document.tenant.json";

import {
  DynamicDocumentGroup,
  DynamicDocumentItemData,
  FormattedDocument,
  InstallationModuleData
} from "@/types.js";

import parse from "./parse";

export default (
  source: DynamicDocumentGroup[],
  data: DynamicDocumentItemData[],
  installationModuleData?: InstallationModuleData
): FormattedDocument => {
  return source
    .map(doc => ({
      title: doc.title,
      items: doc.items.flatMap(item =>
        parse.item(
          item,
          data.find(d => d.field === item.field)!,
          installationModuleData?.[item.field]
        )
      )
    }))
    .filter(doc => doc.items.length);
};

export const documents = {
  ["METER-REGULAR"]: meterRegular as DynamicDocumentGroup[],
  ["METER_MAAS-REGULAR"]: meterMaas as DynamicDocumentGroup[],
  ["PANELS-REGULAR"]: panels as DynamicDocumentGroup[],
  ["TENANT"]: tenant as DynamicDocumentGroup[]
};
